import React, { useEffect } from 'react'
import { ErrorWrapper, Text, Err } from './ErrorStyles'
import useSound from 'use-sound'
import ErrorSFX from '../../../lib/audio/error.mp3'
import NotificationSFX from '../../../lib/audio/notif.mp3'

interface Error_props {
  text: string
  error: boolean
  clickHandler: () => void
  fadeOut: boolean
  showLoader: boolean
  audio: any
}

export default function Error({
  text,
  error,
  clickHandler,
  fadeOut,
  showLoader,
  audio,
}: Error_props) {
  const { sound, isSoundOff } = audio

  const [playErrorSFX] = useSound(ErrorSFX, {
    volume: parseFloat(sound) / 100,
  })
  const [playNotificationSFX] = useSound(NotificationSFX, {
    volume: parseFloat(sound) / 100,
  })
  useEffect(() => {
    if (!isSoundOff) {
      error && text ? playNotificationSFX() : playErrorSFX()
    }
  }, [isSoundOff, playErrorSFX, playNotificationSFX])

  return (
    <ErrorWrapper
      errorType={error}
      onClick={() => clickHandler()}
      fadeOut={fadeOut}
    >
      <Err showLoader={showLoader}>
        <Text errorType={error} showLoader={showLoader}>
          {text}
        </Text>
      </Err>
    </ErrorWrapper>
  )
}
